/* ==========================================================================
   UTILITY FUNCTIONS - Run immediately (not dependent on DOM)
   ========================================================================== */

/* ----------
   LENIS SMOOTH SCROLLING - Initialize immediately
   ---------- */
const lenis = new Lenis();

// Expose lenis globally for use in sections
window.lenis = lenis;

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

/* ==========================================================================
   MAIN DOM CONTENT LOADED - Single entry point
   ========================================================================== */
document.addEventListener("DOMContentLoaded", () => {
  
  /* ----------
     GSAP PLUGINS REGISTRATION
     ---------- */
  if (typeof gsap !== "undefined") {
    gsap.registerPlugin(ScrollTrigger, SplitText);
    
    // Configure ScrollTrigger defaults to handle mid-page loads
    ScrollTrigger.config({
      autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
    });
    
    // Refresh ScrollTrigger after images and fonts load
    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });
  }
  
  /* ----------
     BACK TO TOP BUTTON
     ---------- */
  const backToTopButton = document.getElementById('back-to-top');
  
  if (backToTopButton) {
    // Use Lenis scroll position instead of native scrollTop
    lenis.on('scroll', ({ scroll }) => {
      if (scroll > 200) {
        backToTopButton.style.display = 'flex';
      } else {
        backToTopButton.style.display = 'none';
      }
    });

    backToTopButton.addEventListener('click', (e) => {
      e.preventDefault();
      lenis.scrollTo(0, {
        duration: 1,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        lock: true
      });
    });

      // --- Radial fill effect for back-to-top button ---
      if (typeof gsap !== "undefined") {
        // Create overlay with subtle white tint
        const fillOverlay = document.createElement('div');
        fillOverlay.className = 'btn-fill-overlay';
        fillOverlay.style.cssText = `
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 0;
          height: 0;
          border-radius: 50%;
          pointer-events: none;
          z-index: 0;
          background-color: rgba(255, 255, 255, 0.2);
          will-change: transform, width, height;
          backface-visibility: hidden;
          transform-style: preserve-3d;
        `;
  // Set overflow: hidden to contain the fill animation, but do not change position
  backToTopButton.style.overflow = 'hidden';
        backToTopButton.insertBefore(fillOverlay, backToTopButton.firstChild);

        // Make sure SVG is above overlay
        const svg = backToTopButton.querySelector('svg');
        if (svg) {
          svg.style.position = 'relative';
          svg.style.zIndex = '1';
        }

        gsap.set(fillOverlay, { width: 0, height: 0 });

        backToTopButton.addEventListener('mouseenter', (e) => {
          gsap.killTweensOf(fillOverlay);
          gsap.killTweensOf(backToTopButton);
          
          const rect = backToTopButton.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          fillOverlay.style.left = `${x}px`;
          fillOverlay.style.top = `${y}px`;
          const size = Math.max(backToTopButton.offsetWidth, backToTopButton.offsetHeight) * 4;
          
          gsap.to(fillOverlay, {
            width: size,
            height: size,
            duration: 1,
            ease: "power2.out"
          });
          
          // Make border fully transparent on hover
          gsap.to(backToTopButton, { 
            borderColor: 'rgba(0, 0, 0, 0)', 
            duration: 0.3,
            ease: "power2.out"
          });
        });

        backToTopButton.addEventListener('mouseleave', () => {
          gsap.killTweensOf(fillOverlay);
          gsap.killTweensOf(backToTopButton);
          
          gsap.to(fillOverlay, {
            width: 0,
            height: 0,
            duration: 0.5,
            ease: "power2.out"
          });
          
          // Reset border color
          gsap.to(backToTopButton, { 
            borderColor: '#2151C5', 
            duration: 0.3,
            ease: "power2.out"
          });
        });
      }
  }

  /* ----------
     HEART SCREENING BUTTONS - Radial fill from mouse position
     Match timings/behavior with back-to-top/pricing buttons
     ---------- */
  const screeningButtons = document.querySelectorAll('.screening-button');
  if (screeningButtons.length && typeof gsap !== "undefined") {
    screeningButtons.forEach(btn => {
      // Store original border color
      const computedStyle = window.getComputedStyle(btn);
      const originalBorderColor = computedStyle.borderColor;
      
      // Create overlay with subtle darkening
      const fillOverlay = document.createElement('div');
      fillOverlay.className = 'btn-fill-overlay';
      fillOverlay.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-radius: 50%;
        pointer-events: none;
        z-index: 0;
        background-color: rgba(0, 0, 0, 0.04);
        will-change: transform, width, height;
        backface-visibility: hidden;
        transform-style: preserve-3d;
      `;

      // Ensure container clips overlay
      btn.style.overflow = 'hidden';
      btn.style.position = btn.style.position || 'relative';
      btn.insertBefore(fillOverlay, btn.firstChild);

      gsap.set(fillOverlay, { width: 0, height: 0 });

      btn.addEventListener('mouseenter', (e) => {
        gsap.killTweensOf(fillOverlay);
        gsap.killTweensOf(btn);
        
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        fillOverlay.style.left = `${x}px`;
        fillOverlay.style.top = `${y}px`;
        const size = Math.max(btn.offsetWidth, btn.offsetHeight) * 4;
        gsap.to(fillOverlay, {
          width: size,
          height: size,
          duration: 1,
          ease: "power2.out",
        });
        
        // Make border transparent on hover
        gsap.to(btn, { 
          borderColor: 'rgba(0, 0, 0, 0)', 
          duration: 0.3,
          ease: "power2.out"
        });
      });

      btn.addEventListener('mouseleave', () => {
        gsap.killTweensOf(fillOverlay);
        gsap.killTweensOf(btn);
        
        gsap.to(fillOverlay, {
          width: 0,
          height: 0,
          duration: 0.5,
          ease: "power2.out",
        });
        
        // Reset border color to original
        gsap.to(btn, { 
          borderColor: originalBorderColor, 
          duration: 0.3,
          ease: "power2.out"
        });
      });
    });
  }

  /* ----------
     CHOOSE DURATION BUTTON - Scroll to top
     ---------- */
  const chooseDurationBtn = document.getElementById('choose-duration-btn');
  
  if (chooseDurationBtn) {
    chooseDurationBtn.addEventListener('click', (e) => {
      e.preventDefault();
      lenis.scrollTo(0, {
        duration: 1,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        lock: true
      });
    });
  }

  /* ----------
     DURATION OPTIONS - Dynamic currency buttons scroll to top
     Ensure clicks work even during momentum by using lock:true
     ---------- */
  const dynamicCurrencyButtons = document.querySelectorAll('[id^="dynamic-currency-btn-"]');
  if (dynamicCurrencyButtons.length) {
    dynamicCurrencyButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.lenis) {
          window.lenis.scrollTo(0, {
            duration: 1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            lock: true,
          });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    });
  }

  /* ----------
     LOOKBOOK CARDS
     ---------- */
  const lookIcon1 = document.querySelector("#look1");
  const lookCard1 = document.querySelector("#lookcard1");
  const exitlookicon1 = document.querySelector("#exitlookicon1");
  const lookIcon2 = document.querySelector("#look2");
  const lookCard2 = document.querySelector("#lookcard2");
  const exitlookicon2 = document.querySelector("#exitlookicon2");
  const lookIcon3 = document.querySelector("#look3");
  const lookCard3 = document.querySelector("#lookcard3");
  const exitlookicon3 = document.querySelector("#exitlookicon3");
  const lookIcon4 = document.querySelector("#look4");
  const lookCard4 = document.querySelector("#lookcard4");
  const exitlookicon4 = document.querySelector("#exitlookicon4");
  const lookIcon5 = document.querySelector("#look5");
  const lookCard5 = document.querySelector("#lookcard5");
  const exitlookicon5 = document.querySelector("#exitlookicon5");

  if (lookIcon1 && lookCard1 && exitlookicon1) {
    lookIcon1.addEventListener("click", () => {
      lookCard1.classList.remove("hidden");
      lookCard2?.classList.add("hidden");
      lookCard3?.classList.add("hidden");
      lookCard4?.classList.add("hidden");
      lookCard5?.classList.add("hidden");
    });

    exitlookicon1.addEventListener("click", () => {
      lookCard1.classList.add("hidden");
    });
  }

  if (lookIcon2 && lookCard2 && exitlookicon2) {
    lookIcon2.addEventListener("click", () => {
      lookCard1?.classList.add("hidden");
      lookCard2.classList.remove("hidden");
      lookCard3?.classList.add("hidden");
      lookCard4?.classList.add("hidden");
      lookCard5?.classList.add("hidden");
    });

    exitlookicon2.addEventListener("click", () => {
      lookCard2.classList.add("hidden");
    });
  }

  if (lookIcon3 && lookCard3 && exitlookicon3) {
    lookIcon3.addEventListener("click", () => {
      lookCard1?.classList.add("hidden");
      lookCard2?.classList.add("hidden");
      lookCard3.classList.remove("hidden");
      lookCard4?.classList.add("hidden");
      lookCard5?.classList.add("hidden");
    });

    exitlookicon3.addEventListener("click", () => {
      lookCard3.classList.add("hidden");
    });
  }

  if (lookIcon4 && lookCard4 && exitlookicon4) {
    lookIcon4.addEventListener("click", () => {
      lookCard1?.classList.add("hidden");
      lookCard2?.classList.add("hidden");
      lookCard3?.classList.add("hidden");
      lookCard4.classList.remove("hidden");
      lookCard5?.classList.add("hidden");
    });

    exitlookicon4.addEventListener("click", () => {
      lookCard4.classList.add("hidden");
    });
  }

  if (lookIcon5 && lookCard5 && exitlookicon5) {
    lookIcon5.addEventListener("click", () => {
      lookCard1?.classList.add("hidden");
      lookCard2?.classList.add("hidden");
      lookCard3?.classList.add("hidden");
      lookCard4?.classList.add("hidden");
      lookCard5.classList.remove("hidden");
    });

    exitlookicon5.addEventListener("click", () => {
      lookCard5.classList.add("hidden");
    });
  }

  /* ----------
     PRODUCT MEDIA OVERLAY
     ---------- */
  (function initProductMediaOverlay() {
    const hasGSAP = typeof window.gsap !== "undefined";

    function ensureOverlay() {
      let overlay = document.getElementById("image-overlay");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = "image-overlay";
        overlay.className = "fixed inset-0 hidden z-[9999]";
        overlay.innerHTML = `
        <div id="overlay-backdrop" class="absolute inset-0 bg-black/80 opacity-0"></div>
        <button id="close-overlay" type="button" class="cursor-pointer absolute top-6 right-6 z-[10000] text-white inline-flex items-center justify-center w-10 h-10 rounded-full bg-black/60 hover:bg-black/80 focus:outline-none focus:ring-2 focus:ring-white">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Chiudi</span>
        </button>
        <div class="w-full h-full flex items-center justify-center">
          <img id="overlay-image" src="" alt="Immagine ingrandita" class="max-w-[90%] max-h-[90%] rounded-[20px] shadow-lg opacity-0 z-[9999]">
        </div>
      `;
        document.body.appendChild(overlay);
      }
      return overlay;
    }

    function animateIn(overlayImg, backdrop) {
      if (hasGSAP) {
        gsap.set(overlayImg, { scale: 0.92 });
        gsap.to(backdrop, { opacity: 1, duration: 0.2, ease: "power2.out" });
        gsap.to(overlayImg, {
          opacity: 1,
          scale: 1,
          duration: 0.35,
          ease: "power2.out",
          delay: 0.05,
        });
      } else {
        backdrop.style.opacity = 1;
        overlayImg.style.opacity = 1;
      }
    }

    function animateOut(overlayImg, backdrop, onDone) {
      if (hasGSAP) {
        gsap.to(overlayImg, {
          opacity: 0,
          scale: 0.92,
          duration: 0.25,
          ease: "power2.in",
        });
        gsap.to(backdrop, {
          opacity: 0,
          duration: 0.25,
          ease: "power2.in",
          onComplete: onDone,
        });
      } else {
        overlayImg.style.opacity = 0;
        backdrop.style.opacity = 0;
        onDone();
      }
    }

    function bindImageOverlay() {
      const overlay = ensureOverlay();
      const backdrop = overlay.querySelector("#overlay-backdrop");
      const overlayImg = overlay.querySelector("#overlay-image");
      const closeBtn = overlay.querySelector("#close-overlay");

      if (!overlay || !backdrop || !overlayImg || !closeBtn) return;

      const thumbs = document.querySelectorAll(".thumbnail");
      if (!thumbs.length) return;

      function openOverlay(src) {
        overlayImg.src = src;
        overlay.classList.remove("hidden");
        overlayImg.style.opacity = 0;
        backdrop.style.opacity = 0;
        animateIn(overlayImg, backdrop);
      }

      function closeOverlay() {
        animateOut(overlayImg, backdrop, () => {
          overlay.classList.add("hidden");
          overlayImg.src = "";
        });
      }

      thumbs.forEach((img) => {
        if (img._overlayBound) {
          img.removeEventListener("click", img._overlayBound);
        }
        const handler = () => openOverlay(img.src);
        img.addEventListener("click", handler);
        img._overlayBound = handler;
      });

      if (!backdrop._overlayBound) {
        backdrop.addEventListener("click", closeOverlay);
        backdrop._overlayBound = true;
      }

      if (!closeBtn._overlayBound) {
        closeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          closeOverlay();
        });
        closeBtn._overlayBound = true;
      }

      if (!document._overlayEscBound) {
        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && !overlay.classList.contains("hidden")) {
            closeOverlay();
          }
        });
        document._overlayEscBound = true;
      }
    }
    
    bindImageOverlay();
  })();

  /* ----------
     GSAP ANIMATIONS
     ---------- */
  if (typeof gsap !== "undefined") {

  // Hover effect on tertiary links (excluding buttons)
  gsap.set("header a:not(.btn):not(.btn-secondary), footer a:not(.btn):not(.btn-secondary), .cart, #unmute-video, #dropdown-menu li", {
    y: 0,
  });

  const links = document.querySelectorAll("header a:not(.btn):not(.btn-secondary), footer a:not(.btn):not(.btn-secondary), .cart, #unmute-video, #dropdown-menu li");

  links.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      gsap.to(link, {
        duration: 0.2,
        ease: "power1.inOut",
        y: -5,
      });
    });

    link.addEventListener("mouseleave", () => {
      gsap.to(link, {
        duration: 0.2,
        ease: "power1.inOut",
        y: 0,
      });
    });
  });

  // Split text by lines
  gsap.set(".animate-text-lines", {
    opacity: 1,
  });

  document.fonts.ready.then(() => {
    let texts = document.querySelectorAll(".animate-text-lines");

    texts.forEach((text) => {
      const split = SplitText.create(text, {
        type: "words,lines",
        mask: "lines",
        linesClass: "line",
        autoSplit: true,
        onSplit: (instance) => {
          console.log("split");
          
          gsap.set(instance.lines, {
            opacity: 0,
            yPercent: 120,
          });
          
          ScrollTrigger.create({
            trigger: text,
            start: "top 80%",
            toggleActions: "play none none none",
            onEnter: () => {
              gsap.to(instance.lines, {
                opacity: 1,
                yPercent: 0,
                duration: 1,
                stagger: 0.1,
                ease: "power2.out",
              });
            },
          });
        },
      });
    });
  });

  // Split text by words
  document.fonts.ready.then(() => {
    let texts = document.querySelectorAll(".animate-text-words");

    texts.forEach((text) => {
      const split = new SplitText(text, {
        type: "words",
      });

      gsap.set(split.words, {
        opacity: 0,
        yPercent: 60,
      });

      ScrollTrigger.create({
        trigger: text,
        start: "top 80%",
        toggleActions: "play none none none",
        onEnter: () => {
          gsap.to(split.words, {
            opacity: 1,
            yPercent: 0,
            stagger: 0.1,
            duration: 0.5,
            ease: "power1.out",
          });
        },
      });
    });
  });

  // Testimnonial cards animation
  const cards = document.querySelectorAll(".testimonial-card");

  cards.forEach((card) => {
    card.addEventListener("mouseenter", () => {
      const tl = gsap.timeline();

      tl.to(card, {
        gridColumn: "span 6",
        duration: 0,
        ease: "expo.inOut",
      });

      tl.to(
        card.querySelectorAll(".testimonial-text"),
        {
          opacity: 1,
          duration: 0.3,
          ease: "power2.inOut",
          stagger: 0.1,
        },
        "<"
      );

      cards.forEach((other) => {
        if (other !== card) {
          gsap.set(other, {
            display: "none",
            duration: 0,
            ease: "power2.inOut",
          });
        }
      });
    });

    card.addEventListener("mouseleave", () => {
      const tl = gsap.timeline();

      tl.to(card, {
        gridColumn: card.classList.contains("large-card") ? "span 4" : "span 1",
        duration: 0,
        ease: "power2.inOut",
      });

      tl.to(
        card.querySelectorAll(".testimonial-text"),
        {
          opacity: card.classList.contains("testimonial-text-default") ? 1 : 0,
          duration: 0,
          ease: "power2.inOut",
          delay: 0,
        },
        "<"
      );

      cards.forEach((other) => {
        if (other !== card) {
          gsap.set(other, {
            display: "block",
            autoAlpha: 1,
            delay: 0,
            ease: "power2.inOut",
          });
        }
      });
    });
  });

  (() => {
    // Radial fill button hover effect with subtle color changes
    document.querySelectorAll(".btn, .btn-secondary, .btn-tertiary").forEach((btn) => {
      const isSecondary = btn.classList.contains("btn-secondary");
      const isTertiary = btn.classList.contains("btn-tertiary");
      
      // Store original border color
      const computedStyle = window.getComputedStyle(btn);
      const originalBorderColor = computedStyle.borderColor;
      
      // Create a fill overlay element with lighter/darker shade
      const fillOverlay = document.createElement('div');
      fillOverlay.className = 'btn-fill-overlay';
      fillOverlay.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-radius: 50%;
        pointer-events: none;
        z-index: 0;
        background-color: ${isSecondary || isTertiary ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.2)'};
        will-change: transform, width, height;
        backface-visibility: hidden;
        transform-style: preserve-3d;
      `;
      
      // Insert overlay as first child
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.insertBefore(fillOverlay, btn.firstChild);
      
      // Make sure text and icon are above overlay
      const textElements = btn.querySelectorAll('p, .primary-btn-icon, svg');
      textElements.forEach(el => {
        el.style.position = 'relative';
        el.style.zIndex = '1';
      });
      
      // Set initial GSAP state
      gsap.set(fillOverlay, { width: 0, height: 0 });
      
      btn.addEventListener("mouseenter", (e) => {
        // Kill all ongoing tweens to prevent conflicts
        gsap.killTweensOf(fillOverlay);
        gsap.killTweensOf(btn);
        
        // Get mouse position relative to button
        const rect = btn.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Position overlay at mouse entry point
        fillOverlay.style.left = `${x}px`;
        fillOverlay.style.top = `${y}px`;
        
        // Expand circle to fill button
        const size = Math.max(btn.offsetWidth, btn.offsetHeight) * 3.5;
        gsap.to(fillOverlay, {
          width: size,
          height: size,
          duration: 1,
          ease: "power2.out"
        });
        
        // Make border transparent on hover
        gsap.to(btn, { 
          borderColor: 'rgba(0, 0, 0, 0)', 
          duration: 0.3,
          ease: "power2.out"
        });
      });

      btn.addEventListener("mouseleave", () => {
        // Kill all ongoing tweens to prevent conflicts
        gsap.killTweensOf(fillOverlay);
        gsap.killTweensOf(btn);
        
        // Shrink circle back to nothing
        gsap.to(fillOverlay, {
          width: 0,
          height: 0,
          duration: 0.5,
          ease: "power2.out"
        });
        
        // Reset border color to original
        gsap.to(btn, { 
          borderColor: originalBorderColor, 
          duration: 0.3,
          ease: "power2.out"
        });
      });
    });
  })();

  (() => {
    // Radial fill hover effect for pricing arrow icons
    document.querySelectorAll(".pricing-arrow-icon").forEach((icon) => {
      // Mark as processed to avoid duplicate handling
      icon.dataset.hoverProcessed = 'true';
      
      // Create a fill overlay element
      const fillOverlay = document.createElement('div');
      fillOverlay.className = 'pricing-fill-overlay';
      fillOverlay.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-radius: 50%;
        pointer-events: none;
        z-index: 0;
        background-color: rgba(255, 255, 255, 0.2);
        will-change: transform, width, height;
        backface-visibility: hidden;
        transform-style: preserve-3d;
      `;
      
      // Set position relative and insert overlay
      icon.style.position = 'relative';
      icon.style.overflow = 'hidden';
      icon.insertBefore(fillOverlay, icon.firstChild);
      
      // Make sure SVG is above overlay
      const svg = icon.querySelector('svg');
      if (svg) {
        svg.style.position = 'relative';
        svg.style.zIndex = '1';
      }
      
      // Set initial GSAP state
      gsap.set(fillOverlay, { width: 0, height: 0 });
      
      // Get parent link for event handling
      const parentLink = icon.closest('a');
      const eventTarget = parentLink || icon;
      
      eventTarget.addEventListener("mouseenter", (e) => {
        // Kill all ongoing tweens to prevent conflicts
        gsap.killTweensOf(fillOverlay);
        gsap.killTweensOf(icon);
        
        // Get mouse position relative to icon
        const rect = icon.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Position overlay at mouse entry point
        fillOverlay.style.left = `${x}px`;
        fillOverlay.style.top = `${y}px`;
        
        // Expand circle to fill icon
        const size = Math.max(icon.offsetWidth, icon.offsetHeight) * 3.5;
        gsap.to(fillOverlay, {
          width: size,
          height: size,
          duration: 1,
          ease: "power2.out"
        });
        
        // Make border transparent on hover
        gsap.to(icon, { 
          borderColor: 'rgba(0, 0, 0, 0)', 
          duration: 0.3,
          ease: "power2.out"
        });
      });

      eventTarget.addEventListener("mouseleave", () => {
        // Kill all ongoing tweens to prevent conflicts
        gsap.killTweensOf(fillOverlay);
        gsap.killTweensOf(icon);
        
        // Shrink circle back to nothing
        gsap.to(fillOverlay, {
          width: 0,
          height: 0,
          duration: 0.5,
          ease: "power2.out"
        });
        
        // Reset border color
        gsap.to(icon, { 
          borderColor: 'transparent', 
          duration: 0.3,
          ease: "power2.out"
        });
      });
    });
  })();

  (() => {
    // Radial fill hover effect for standalone arrow icons (primary-btn-icon)
    document.querySelectorAll(".primary-btn-icon").forEach((icon) => {
      // Skip if already processed, inside a button, or is a pricing arrow
      if (icon.dataset.hoverProcessed || 
          icon.closest(".btn, .btn-secondary, .btn-tertiary") || 
          icon.classList.contains("pricing-arrow-icon")) {
        return;
      }
      
      // Mark as processed
      icon.dataset.hoverProcessed = 'true';
      
      // Check background color to determine overlay color
      const computedStyle = window.getComputedStyle(icon);
      const bgColor = computedStyle.backgroundColor;
      
      // If background is white/light, use dark overlay; if blue/dark, use light overlay
      const isLightBg = bgColor.includes('255, 255, 255') || bgColor.includes('rgb(255, 255, 255)');
      
      // Create a fill overlay element
      const fillOverlay = document.createElement('div');
      fillOverlay.className = 'icon-fill-overlay';
      fillOverlay.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-radius: 50%;
        pointer-events: none;
        z-index: 0;
        background-color: ${isLightBg ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.2)'};
        will-change: transform, width, height;
        backface-visibility: hidden;
        transform-style: preserve-3d;
      `;
      
      // Set position relative and insert overlay
      icon.style.position = 'relative';
      icon.style.overflow = 'hidden';
      icon.insertBefore(fillOverlay, icon.firstChild);
      
      // Make sure SVG is above overlay
      const svg = icon.querySelector('svg');
      if (svg) {
        svg.style.position = 'relative';
        svg.style.zIndex = '1';
      }
      
      // Set initial GSAP state
      gsap.set(fillOverlay, { width: 0, height: 0 });
      
      icon.addEventListener("mouseenter", (e) => {
        // Kill all ongoing tweens to prevent conflicts
        gsap.killTweensOf(fillOverlay);
        
        // Get mouse position relative to icon
        const rect = icon.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Position overlay at mouse entry point
        fillOverlay.style.left = `${x}px`;
        fillOverlay.style.top = `${y}px`;
        
        // Expand circle to fill icon
        const size = Math.max(icon.offsetWidth, icon.offsetHeight) * 3.5;
        gsap.to(fillOverlay, {
          width: size,
          height: size,
          duration: 1,
          ease: "power2.out"
        });
      });

      icon.addEventListener("mouseleave", () => {
        // Kill all ongoing tweens to prevent conflicts
        gsap.killTweensOf(fillOverlay);
        
        // Shrink circle back to nothing
        gsap.to(fillOverlay, {
          width: 0,
          height: 0,
          duration: 0.5,
          ease: "power2.out"
        });
      });
    });
  })();

  (function initInfiniteBanner(selector = ".marquee", speed = 80) {
    const marquee = document.querySelector(selector);
    if (!marquee) return;

    const track = marquee.querySelector(".marquee__track");
    const baseNodes = Array.from(track.children);

    const build = () => {
      gsap.killTweensOf(track);
      track.style.transform = "";

      // reset to 1 set and measure after fonts/layout
      track.innerHTML = "";
      baseNodes.forEach((n) => track.appendChild(n.cloneNode(true)));

      const containerW = marquee.offsetWidth;
      const oneSetW = track.scrollWidth;
      if (!oneSetW) return;

      // duplicate until we cover ~2× viewport (so there's always text)
      const needed = Math.max(2, Math.ceil((containerW * 2) / oneSetW));
      track.innerHTML = "";
      for (let i = 0; i < needed; i++) {
        baseNodes.forEach((n) => track.appendChild(n.cloneNode(true)));
      }

      const items = Array.from(track.children);
      const gapPx = parseFloat(getComputedStyle(track).gap) || 0;
      const widths = items.map((el) => el.getBoundingClientRect().width);

      // lay out items side-by-side manually
      let x = 0;
      items.forEach((el, i) => {
        gsap.set(el, {
          x,
          yPercent: -50,
          position: "absolute",
          top: "50%",
          left: 0,
          willChange: "transform",
        });
        x += widths[i] + gapPx;
      });
      const loopW = x - gapPx;

      // ticker loop: move left; recycle each item to the end when it exits
      let last = performance.now(),
        raf;
      function tick(t) {
        const dt = (t - last) / 1000;
        last = t;
        const dx = -speed * dt;

        for (let i = 0; i < items.length; i++) {
          const w = widths[i];
          let xi = gsap.getProperty(items[i], "x") + dx;
          if (xi < -w) xi += loopW + gapPx; // wrap this item to the tail
          gsap.set(items[i], { x: xi });
        }
        raf = requestAnimationFrame(tick);
      }
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(tick);

      // rebuild on resize
      window.addEventListener(
        "resize",
        gsap.utils.debounce(() => {
          cancelAnimationFrame(raf);
          // restore DOM to base before rebuilding
          track.innerHTML = "";
          baseNodes.forEach((n) => track.appendChild(n.cloneNode(true)));
          build();
        }, 200),
        { once: true }
      );
    };

    (document.fonts?.ready ?? Promise.resolve()).then(build);
  })();

  //Reveal Animation

  gsap.registerPlugin(ScrollTrigger);

  // For each section that contains .reveal-new elements
  document.querySelectorAll(".reveal-section").forEach((section) => {
    const items = section.querySelectorAll(".reveal-new");

    gsap.fromTo(
      items,
      { opacity: 0, y: 30, scale: 0.95 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
      }
    );
  });

  // Logos animated

  document.querySelectorAll(".animate-logo-wrapper").forEach((wrapper) => {
    const logos = wrapper.querySelectorAll("img");

    gsap
      .timeline({
        defaults: { duration: 0.6, ease: "power2.out" },
        scrollTrigger: {
          trigger: wrapper,
          start: "top 85%",
          end: "bottom 15%",
          toggleActions: "play none none",
        },
      })
      .fromTo(
        logos,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, stagger: 0.15 }
      );
  });

  document.querySelectorAll("a:not(.btn):not(.btn-secondary):not(.btn-tertiary):not(:has(.primary-btn-icon)):not(.screening-button)").forEach((link) => {
    link.addEventListener("mouseenter", () => {
      gsap.to(link, {
        y: -3,
        duration: 0.25,
        ease: "power2.out",
      });
    });

    link.addEventListener("mouseleave", () => {
      gsap.to(link, {
        y: 0,
        duration: 0.25,
        ease: "power2.inOut",
      });
    });
  });

  // Small image reveal animation
  const subtleImages = document.querySelectorAll(
    ".animate-image-reveal-subtle"
  );

  subtleImages.forEach((img) => {
    ScrollTrigger.create({
      trigger: img,
      start: "top 85%",
      toggleActions: "play none none none",
      onEnter: () => {
        gsap.to(img, {
          opacity: 1,
          duration: 1,
          ease: "power2.out",
        });
      },
    });
  });

  const carousel = document.querySelector(".carousel-animate-in");

  if (carousel) {
    ScrollTrigger.create({
      trigger: carousel,
      start: "top 80%",
      toggleActions: "play none none none",
      onEnter: () => {
        gsap.to(carousel, {
          opacity: 1,
          x: 0,
          duration: 2,
          ease: "power2.out",
        });
      },
    });
  }

  // Select all elements with the "up-reveal-animation" class
  const revealElements = document.querySelectorAll(".up-reveal-animation");

  revealElements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top 80%",
      toggleActions: "play none none none",
      onEnter: () => {
        gsap.to(el, {
          opacity: 1,
          yPercent: 0,
          duration: 1,
          ease: "power2.out",
        });
      },
    });
  });

  //Size guide
  const sizeGuideButton = document.querySelector("#size-guide-button");
  const sizeGuideContainer = document.querySelector("#size-guide-container");
  const closeSizeGuide = document.querySelector("#close-size-guide");

  if (sizeGuideButton && sizeGuideContainer && closeSizeGuide) {
    sizeGuideButton.addEventListener("click", () => {
      sizeGuideContainer.classList.remove("hidden");
    });

    closeSizeGuide.addEventListener("click", () => {
      sizeGuideContainer.classList.add("hidden");
    });
  }

  /* ----------
     STATS CAROUSEL - Arrow Navigation
     ---------- */
  const statsSection = document.querySelector('[data-section-type="stats"]');
  const statsScrollContainer = statsSection?.querySelector('.stats-scroll-container');
  const prevBtn = statsSection?.querySelector('.stats-prev');
  const nextBtn = statsSection?.querySelector('.stats-next');
  
  if (statsSection && statsScrollContainer && prevBtn && nextBtn) {
    let currentIndex = 0;
    
    const getCards = () => statsScrollContainer.querySelectorAll('.flex-shrink-0');
    
    const updateButtonStates = () => {
      const cards = getCards();
      prevBtn.style.opacity = currentIndex === 0 ? '0.3' : '1';
      prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
      nextBtn.style.opacity = currentIndex >= cards.length - 1 ? '0.3' : '1';
      nextBtn.style.pointerEvents = currentIndex >= cards.length - 1 ? 'none' : 'auto';
    };
    
    const scrollToIndex = (index) => {
      const cards = getCards();
      if (index < 0 || index >= cards.length) return;
      
      currentIndex = index;
      const card = cards[index];
      
      // Scroll the card into view
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      
      updateButtonStates();
    };
    
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToIndex(currentIndex - 1);
    });
    
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      scrollToIndex(currentIndex + 1);
    });
    
    // Initialize button states
    updateButtonStates();
  }

  } // End GSAP animations check

  /* ----------
     TESTIMONIAL CAROUSEL
     ---------- */
  function initTestimonialCarousel(root) {
    if (!root) return;

    const inner = root.querySelector(".carousel-inner");
    if (!inner) return;

    const slides = Array.from(inner.children);
    const dots = Array.from(root.querySelectorAll(".dot"));
    const total = slides.length;

    const hasCover = slides.length === dots.length + 1;

    const autoplay = root.dataset.autoplay === "true";
    const speed = parseInt(root.dataset.speed, 10) || 5000;

    let index = 0;
    let timer = null;

    const goTo = (i) => {
      if (!total) return;
      index = (i + total) % total;
      inner.style.transform = `translateX(-${index * 100}%)`;

      // Hide dots on cover slide
      const dotsContainer = root.querySelector(".carousel-dots");
      if (dotsContainer) {
        if (index === 0 && hasCover) {
          dotsContainer.classList.add("hidden");
        } else {
          dotsContainer.classList.remove("hidden");
        }
      }

      dots.forEach((d, di) => {
        // Map slide index -> dot index
        // If cover exists: slide 1 -> dot 0, slide 2 -> dot 1, etc.
        // If no cover:     slide 0 -> dot 0, etc.
        const mappedDotIndex = hasCover ? index - 1 : index;
        const isActive = mappedDotIndex === di && (!hasCover || index > 0);

        if (isActive) {
          d.classList.add("bg-white");
          d.classList.remove("bg-white/50");
          d.setAttribute("aria-current", "true");
        } else {
          d.classList.remove("bg-white");
          d.classList.add("bg-white/50");
          d.removeAttribute("aria-current");
        }
      });
    };

    const next = () => goTo(index + 1);
    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };
    const start = () => {
      if (autoplay && total > 1) {
        stop();
        timer = setInterval(next, speed);
      }
    };

    // dots click
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        stop();
        const targetIndex = hasCover ? i + 1 : i; // skip over cover if present
        goTo(targetIndex);
        start();
      });
    });

    // arrows
    const prevBtn = root.querySelector(".carousel-arrow.left");
    const nextBtn = root.querySelector(".carousel-arrow.right");

    const prev = () => {
      stop();
      goTo(index - 1);
      start();
    };

    const nextSlide = () => {
      stop();
      goTo(index + 1);
      start();
    };

    if (prevBtn) prevBtn.addEventListener("click", prev);
    if (nextBtn) nextBtn.addEventListener("click", nextSlide);

    // pause when tab hidden
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
      else start();
    });

    // init but don't autoplay yet
    goTo(0);

    // Wait until the carousel scrolls into view before starting autoplay
    if (typeof gsap !== "undefined" && gsap && gsap.registerPlugin) {
      gsap.registerPlugin(ScrollTrigger);

      ScrollTrigger.create({
        trigger: root,
        start: "top 80%",
        once: true,
        onEnter: () => {
          goTo(0);
          start();
        },
      });
    } else {
      start();
    }

    // store cleanup for Theme Editor
    root.__carouselCleanup = () => {
      stop();
      dots.forEach((d) => d.replaceWith(d.cloneNode(true)));
      root.replaceWith(root.cloneNode(true));
      const prevBtn = root.querySelector(".carousel-arrow.left");
      const nextBtn = root.querySelector(".carousel-arrow.right");
      if (prevBtn) prevBtn.replaceWith(prevBtn.cloneNode(true));
      if (nextBtn) nextBtn.replaceWith(nextBtn.cloneNode(true));
    };
  }

  function initAllTestimonialCarousels(container = document) {
    container.querySelectorAll(".js-testimonial-carousel").forEach((root) => {
      if (!root.__carouselInitialized) {
        initTestimonialCarousel(root);
        root.__carouselInitialized = true;
      }
    });
  }

  // Initialize carousels
  initAllTestimonialCarousels();

  /* ----------
     ECG ANIMATION USING LOTTIE
     ---------- */
  if (window.lottie) {
    const ecgContainer = document.getElementById("ecg-animation");
    if (ecgContainer) {
      lottie.loadAnimation({
        container: ecgContainer,
        path: "https://cdn.shopify.com/s/files/1/0978/0825/3253/files/data.json?v=1760430323",
        renderer: "svg",
        loop: true,
        autoplay: true,
      });
    }
  }

  /* ----------
     UNMUTE HERO VIDEO
     ---------- */
  const unmuteVideoBtn = document.getElementById('unmute-video');
  if (unmuteVideoBtn) {
    unmuteVideoBtn.addEventListener('click', function() {
      const video = document.getElementById('hero-video');
      const muteIcon = document.getElementById('mute-icon');
      const unmuteIcon = document.getElementById('unmute-icon');

      if (video && muteIcon && unmuteIcon) {
        video.muted = !video.muted;

        if (video.muted) {
          muteIcon.style.display = 'block';
          unmuteIcon.style.display = 'none';
        } else {
          muteIcon.style.display = 'none';
          unmuteIcon.style.display = 'block';
        }
      }
    });
  }

  /* ----------
     DROPDOWN MENU FUNCTIONALITY
     ---------- */
  const aboutDropdown = document.getElementById('about-dropdown');
  if (aboutDropdown) {
    aboutDropdown.addEventListener('click', function() {
      const dropdownMenu = document.getElementById('dropdown-menu');
      const dropdownIcon = document.getElementById('dropdown-icon');

      if (dropdownMenu && dropdownIcon) {
        dropdownMenu.classList.toggle('hidden');
        dropdownMenu.classList.toggle('opacity-0');
        dropdownMenu.classList.toggle('translate-y-2');
        dropdownIcon.classList.toggle('rotate-180');
      }
    });
  }

  /* ----------
     THEME EDITOR SUPPORT FOR CAROUSELS
     ---------- */
  document.addEventListener("shopify:section:load", (e) => {
    const sectionEl = document.getElementById(e.detail.sectionId);
    if (sectionEl) initAllTestimonialCarousels(sectionEl);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    const sectionEl = document.getElementById(e.detail.sectionId);
    const root = sectionEl && sectionEl.querySelector(".js-testimonial-carousel");
    if (root && typeof root.__carouselCleanup === "function") {
      root.__carouselCleanup();
    }
  });

  /* ----------
     ADDITIONAL SECTION-SPECIFIC GSAP ANIMATIONS
     ---------- */
  if (typeof gsap !== "undefined") {
    
    // Hero Section Animation
    function heroSectionAnimation() {
      const heroSection = document.querySelector(".hero-section");
      if (!heroSection) return;

      gsap.set(".hero-title", { y: -20, opacity: 0 });
      gsap.set(".hero-subtitle", { y: -20, opacity: 0 });
      gsap.set(".hero-btn", { y: 20, opacity: 0 });
      gsap.set(".hero-banner", { y: 20, opacity: 0 });
      gsap.set("#unmute-video", { y: 20, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".hero-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.to(".hero-title", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to(".hero-btn", { y: 0, opacity: 1, delay: 2, duration: 0.5, ease: "power1.inOut" })
        .to(".hero-banner", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to("#unmute-video", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, "-=0.5");
    }

    // Header Animation (only on index page)
    function headerAnimation() {
      const siteHeader = document.querySelector(".site-header");
      const headerInner = document.querySelector(".header-inner");
      
      if (!siteHeader || !headerInner) return;
      
      // Check if the inline style is present (only on index page)
      const hasInitialHiddenState = headerInner.style.opacity === '0';
      
      if (!hasInitialHiddenState) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".site-header",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.to(".header-inner", { y: 0, opacity: 1, delay: 1.5, duration: 0.8, ease: "power1.inOut" });
    }

    // Statement Animation
    function statementAnimation() {
      const statement = document.querySelector(".statement");
      if (!statement) return;

      gsap.set(".statement-title", { y: -20, opacity: 0 });
      gsap.set(".statement-subtitle", { y: -20, opacity: 0 });
      gsap.set(".statement-citation", { y: 20, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".statement",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.to(".statement-title", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to(".statement-subtitle", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to(".statement-citation", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }

    // Skin Promo Animation
    function skinPromoAnimation() {
      const images = document.querySelectorAll(".animate-image-reveal");
      images.forEach((img) => {
        ScrollTrigger.create({
          trigger: img,
          start: "top 85%",
          toggleActions: "play none none none",
          onEnter: () => {
            gsap.to(img, { clipPath: "inset(0% 0% 0% 0%)", duration: 0.5, ease: "linear" });
          },
        });
      });

      const skinPromo = document.querySelector(".skin-promo");
      if (!skinPromo) return;

      gsap.set(".skin-promo-logo", { y: -20, opacity: 0 });
      gsap.set(".skin-promo-headline", { y: -20, opacity: 0 });
      gsap.set(".skin-promo-text", { y: 20, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".skin-promo",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.to(".skin-promo-logo", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to(".skin-promo-headline", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to(".skin-promo-text", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }

    // Trusted Statement Animation
    function trustedStatementAnimation() {
      const trustedStatement = document.querySelector(".trusted-statement");
      if (!trustedStatement) return;

      gsap.set(".trusted-statement-text", { y: -20, opacity: 0 });
      
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".trusted-statement",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.to(".trusted-statement-text", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }

    // Comfort Section Animation
    function comfortSectionAnimation() {
      const comfortSection = document.querySelector(".comfort-section");
      if (!comfortSection) return;
      
      gsap.set(".comfort-title", { y: -20, opacity: 0 });
      gsap.set(".comfort-description", { y: 20, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".comfort-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      tl.to(".comfort-title", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" })
        .to(".comfort-description", { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }

    // USP Icons Animation
    function uspIconsAnimation() {
      const uspIcons = document.querySelectorAll(".usp-icon");
      if (!uspIcons.length) return;

      uspIcons.forEach((icon, i) => {
        const img = icon.querySelector('.usp-icon-image');
        const title = icon.querySelector('.usp-icon-title');
        const desc = icon.querySelector('.usp-icon-description');
        const smallDesc = icon.querySelector('.usp-icon-small-description');

        if (img) gsap.set(img, { y: -20, opacity: 0 });
        if (title) gsap.set(title, { y: -20, opacity: 0 });
        if (desc) gsap.set(desc, { y: 20, opacity: 0 });
        if (smallDesc) gsap.set(smallDesc, { y: 20, opacity: 0 });
      });

      gsap.timeline({
        scrollTrigger: {
          trigger: ".usp-icons-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      })
      .add(uspIcons.length ? uspIcons : null)
      uspIcons.forEach((icon, i) => {
        const img = icon.querySelector('.usp-icon-image');
        const title = icon.querySelector('.usp-icon-title');
        const desc = icon.querySelector('.usp-icon-description');
        const smallDesc = icon.querySelector('.usp-icon-small-description');

        const tl = gsap.timeline();
        tl.to(img, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, 0)
          .to(title, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, 0.05)
          .to(desc, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, 0.1)
          .to(smallDesc, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, 0.15);

        gsap.timeline({
          scrollTrigger: {
            trigger: icon,
            start: "top 90%",
            toggleActions: "play none none none",
          },
        }).add(tl, i * 0.15);
      });
    }

    // Stats Section Animation
    function statsSectionAnimation() {
      const statsSection = document.querySelector(".stats-section");
      if (!statsSection) return;

      const sectionHeading = statsSection.querySelector(".stats-heading");
      const statsCards = statsSection.querySelectorAll(".stats-card");

      if (sectionHeading) gsap.set(sectionHeading, { y: -20, opacity: 0 });
      statsCards.forEach(card => {
        gsap.set(card, { y: 0, opacity: 0 });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".stats-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      // Animate section heading first
      if (sectionHeading) {
        tl.to(sectionHeading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.in" });
      }

      // Animate each card as a unit, in sequence (faster)
      statsCards.forEach((card, i) => {
        tl.to(card, { y: 0, opacity: 1, duration: 1, ease: "power3.out" }, `-=0.7`);
      });
    }

    // How It Works Section Animation
    function howItWorksAnimation() {
      const howItWorksSection = document.querySelector(".how-it-works-section");
      if (!howItWorksSection) return;

      const heading = howItWorksSection.querySelector(".how-it-works-heading");
      const subheading = howItWorksSection.querySelector(".how-it-works-subheading");
      const footerText = howItWorksSection.querySelector(".how-it-works-footer-text");
      const footerTagline = howItWorksSection.querySelector(".how-it-works-footer-tagline");

      if (heading) gsap.set(heading, { y: -20, opacity: 0 });
      if (subheading) gsap.set(subheading, { y: -20, opacity: 0 });
      if (footerText) gsap.set(footerText, { y: 20, opacity: 0 });
      if (footerTagline) gsap.set(footerTagline, { y: 20, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".how-it-works-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      if (heading) {
        tl.to(heading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (subheading) {
        tl.to(subheading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (footerText) {
        tl.to(footerText, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (footerTagline) {
        tl.to(footerTagline, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
    }

    // Symptoms Section Animation
    function symptomsSectionAnimation() {
    const symptomsSection = document.querySelector(".symptoms-section");
    if (!symptomsSection) return;

    const symptomsHeading = symptomsSection.querySelector(".symptoms-heading");
    const symptomsDescription = symptomsSection.querySelector(".symptoms-description");
    const symptomsButton1 = symptomsSection.querySelector(".symptoms-button-1");
    const symptomsButton2 = symptomsSection.querySelector(".symptoms-button-2");
    const preventativeHeading = symptomsSection.querySelector(".preventative-heading");
    const preventativeDescription = symptomsSection.querySelector(".preventative-description");
    const pricingCard1 = symptomsSection.querySelector(".pricing-card-1");
    const pricingCard2 = symptomsSection.querySelector(".pricing-card-2");
    const pricingCard3 = symptomsSection.querySelector(".pricing-card-3");

    if (symptomsHeading) gsap.set(symptomsHeading, { y: -20, opacity: 0 });
    if (symptomsDescription) gsap.set(symptomsDescription, { y: 20, opacity: 0 });
    if (symptomsButton1) gsap.set(symptomsButton1, { y: 20, opacity: 0 });
    if (symptomsButton2) gsap.set(symptomsButton2, { y: 20, opacity: 0 });
    if (preventativeHeading) gsap.set(preventativeHeading, { y: -20, opacity: 0 });
    if (preventativeDescription) gsap.set(preventativeDescription, { y: 20, opacity: 0 });
    if (pricingCard1) gsap.set(pricingCard1, { y: 0, opacity: 0 });
    if (pricingCard2) gsap.set(pricingCard2, { y: 0, opacity: 0 });
    if (pricingCard3) gsap.set(pricingCard3, { y: 0, opacity: 0 });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".symptoms-section",
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });

    if (symptomsHeading) {
      tl.to(symptomsHeading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    if (symptomsDescription) {
      tl.to(symptomsDescription, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    if (symptomsButton1) {
      tl.to(symptomsButton1, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    if (symptomsButton2) {
      tl.to(symptomsButton2, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    if (preventativeHeading) {
      tl.to(preventativeHeading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut"}, "-=1.5");
    }
    if (preventativeDescription) {
      tl.to(preventativeDescription, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, "-=1.0");
    }
    if (pricingCard1) {
      tl.to(pricingCard1, { y: 0, opacity: 1, duration: 1, ease: "power3.out" }, "-=0.8");
    }
    if (pricingCard2) {
      tl.to(pricingCard2, { y: 0, opacity: 1, duration: 1, ease: "power3.out" }, "-=0.8");
    }
    if (pricingCard3) {
      tl.to(pricingCard3, { y: 0, opacity: 1, duration: 1, ease: "power3.out" }, "-=0.8");
    }
    }

    // Logos Animation Section
    function logosSectionAnimation() {
    const logosSection = document.querySelector(".logos-animation-section");
    if (!logosSection) return;

    const headingIcon = logosSection.querySelector(".logos-heading-icon");
    const heading = logosSection.querySelector(".logos-heading");

    if (headingIcon) gsap.set(headingIcon, { y: -20, opacity: 0 });
    if (heading) gsap.set(heading, { y: -20, opacity: 0 });

    const tlLogos = gsap.timeline({
      scrollTrigger: {
        trigger: ".logos-animation-section",
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });

    if (headingIcon) {
      tlLogos.to(headingIcon, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    if (heading) {
      tlLogos.to(heading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    }

    // Advisors Animation Section
    function advisorsSectionAnimation() {
    const advisorsSection = document.querySelector(".advisors-animation-section");
    if (!advisorsSection) return;

    const heading = advisorsSection.querySelector(".advisors-heading");
    const subheading = advisorsSection.querySelector(".advisors-subheading");
    const advisors = advisorsSection.querySelectorAll(".advisor");
    const footerBold = advisorsSection.querySelector(".advisors-footer-bold");
    const footerText = advisorsSection.querySelector(".advisors-footer-text");
    const button = advisorsSection.querySelector(".advisors-button");

    if (heading) gsap.set(heading, { y: -20, opacity: 0 });
    if (subheading) gsap.set(subheading, { y: -20, opacity: 0 });
    advisors.forEach(advisor => {
      gsap.set(advisor, { y: 0, opacity: 0 });
    });
    if (footerText) gsap.set(footerText, { y: 20, opacity: 0 });
    if (footerBold) gsap.set(footerBold, { y: 20, opacity: 0 });
    if (button) gsap.set(button, { y: 20, opacity: 0 });

    const tlAdvisors = gsap.timeline({
      scrollTrigger: {
        trigger: ".advisors-animation-section",
        start: "top 85%",
        toggleActions: "play none none none",
      },
    });

    if (heading) {
      tlAdvisors.to(heading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    if (subheading) {
      tlAdvisors.to(subheading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
    }
    advisors.forEach((advisor, i) => {
      tlAdvisors.to(advisor, { y: 0, opacity: 1, duration: 1, ease: "power3.out" }, `-=0.7`);
    });
    if (footerBold) {
      tlAdvisors.to(footerBold, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, "-=1.0");
    }
    if (footerText) {
      tlAdvisors.to(footerText, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, "-=0.8");
    }
    if (button) {
      tlAdvisors.to(button, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, "-=0.8");
    }
    }

    // Hospitals Section Animation
    function hospitalsSectionAnimation() {
      const hospitalsSection = document.querySelector(".hospitals-section");
      if (!hospitalsSection) return;

      const logoItems = hospitalsSection.querySelectorAll(".hospital-logo");
      const heading = hospitalsSection.querySelector(".hospitals-heading");

      if (heading) gsap.set(heading, { y: -20, opacity: 0 });
      
      logoItems.forEach((logo) => {
        gsap.set(logo, { y: 20, opacity: 0 });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".hospitals-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      if (heading) {
        tl.to(heading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }

      logoItems.forEach((logo, i) => {
        tl.to(logo, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, i * 0.15);
      });
    }

    // Future Vision Section Animation
    function futureVisionSectionAnimation() {
      const futureVisionSection = document.querySelector(".future-vision-section");
      if (!futureVisionSection) return;

      const heading = futureVisionSection.querySelector(".future-vision-heading");
      const description = futureVisionSection.querySelector(".future-vision-description");
      const futureCard = futureVisionSection.querySelector(".future-vision-card-title");
      const futureCardDescription = futureVisionSection.querySelector(".future-vision-card-description");
      const futureCard2 = futureVisionSection.querySelector(".future-vision-card-title2");
      const futureCardDescription2 = futureVisionSection.querySelector(".future-vision-card-description2");
      const futureDisclaimer = futureVisionSection.querySelector(".future-vision-disclaimer");

      if (heading) gsap.set(heading, { y: -20, opacity: 0 });
      if (description) gsap.set(description, { y: 20, opacity: 0 });
      if (futureCard) gsap.set(futureCard, { y: 0, opacity: 0 });
      if (futureCardDescription) gsap.set(futureCardDescription, { y: 20, opacity: 0 });
      if (futureCard2) gsap.set(futureCard2, { y: 0, opacity: 0 });
      if (futureCardDescription2) gsap.set(futureCardDescription2, { y: 20, opacity: 0 });
      if (futureDisclaimer) gsap.set(futureDisclaimer, { y: 20, opacity: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".future-vision-section",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      if (heading) {
        tl.to(heading, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (description) {
        tl.to(description, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (futureCard) {
        tl.to(futureCard, { y: 0, opacity: 1, duration: 0.5, ease: "power3.out" });
      }
      if (futureCardDescription) {
        tl.to(futureCardDescription, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (futureCard2) {
        tl.to(futureCard2, { y: 0, opacity: 1, duration: 0.5, ease: "power3.out" });
      }
      if (futureCardDescription2) {
        tl.to(futureCardDescription2, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (futureDisclaimer) {
        tl.to(futureDisclaimer, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
    }

    // Footer Animation
    function footerAnimation() {
      const siteFooter = document.querySelector(".site-footer");
      if (!siteFooter) return;

      const logo = siteFooter.querySelector(".footer-logo");
      const footerCopyright = siteFooter.querySelector(".footer-copyright");
      const footerAddress = siteFooter.querySelector(".footer-address");
      const footerLegal = siteFooter.querySelector(".footer-legal");
      const footerLinks = siteFooter.querySelectorAll(".footer-links");

      if (logo) gsap.set(logo, { y: 20, opacity: 0 });
      if (footerCopyright) gsap.set(footerCopyright, { y: 20, opacity: 0 });
      if (footerAddress) gsap.set(footerAddress, { y: 20, opacity: 0 });
      if (footerLegal) gsap.set(footerLegal, { y: 20, opacity: 0 });
      footerLinks.forEach(link => {
        gsap.set(link, { y: 20, opacity: 0 });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".site-footer",
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      if (logo) {
        tl.to(logo, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (footerCopyright) {
        tl.to(footerCopyright, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (footerAddress) {
        tl.to(footerAddress, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      if (footerLegal) {
        tl.to(footerLegal, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
      }
      footerLinks.forEach((link, i) => {
        tl.to(link, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" }, i * 0.1);
      });
    }

    // Generic Animations
    function genericAnimations() {
      document.querySelectorAll('.shopify-section').forEach(section => {
        const group = section.querySelectorAll('.fade-in-on-scroll');
        if (!group.length) return;

        // Set state per-section group, not globally
        gsap.set(group, { y: 20, opacity: 0 });

        ScrollTrigger.create({
          trigger: section,
          start: "top 90%",  // Earlier trigger for smoother reveal
          once: true,
          immediateRender: false,
          fastScrollEnd: true,  // Wait for scroll momentum to settle
          onEnter: () => {
            gsap.to(group, {
              y: 0,
              opacity: 1,
              duration: 0.4,  // Slightly faster
              ease: "power2.out",  // Snappier easing
              stagger: 0.08,  // Reduced stagger
              overwrite: 'auto'  // Kill conflicting animations
            });
          },
          onRefresh: (self) => {
            // If already past trigger point on load, show immediately
            if (self.progress === 1) {
              gsap.set(group, { y: 0, opacity: 1 });
            }
          }
        });
      });
      
      // Delay refresh until layout stable
      requestAnimationFrame(() => {
        ScrollTrigger.refresh();
      });
    }

    // Generic Animations Fast
    function genericAnimationsFast() {
      document.querySelectorAll('.shopify-section').forEach(section => {
        const group = section.querySelectorAll('.fade-in-on-scroll-fast');
        if (!group.length) return;

        // Set state per-section group, not globally
        gsap.set(group, { y: 20, opacity: 0 });

        ScrollTrigger.create({
          trigger: section,
          start: "top 85%",
          once: true,  // Clean up after first fire
          immediateRender: false,
          onEnter: () => {
            gsap.to(group, {
              y: 0,
              opacity: 1,
              duration: 0.5,
              ease: "power1.inOut",
              stagger: 0.15
            });
          },
          onRefresh: (self) => {
            // If already past trigger point on load, animate immediately
            if (self.progress === 1) {
              gsap.set(group, { y: 0, opacity: 1 });
            }
          }
        });
      });
      
      // Refresh to handle sections already in view
      ScrollTrigger.refresh();
    }

    // Article Paragraph Animation
    function articleParagraphsAnimation() {
    const articleParagraphs = document.querySelectorAll(".article p,.article a,.article li,.article h2,.article h3,.article h4,.article blockquote");
    articleParagraphs.forEach((para) => {
      gsap.set(para, { y: 20, opacity: 0 });

      ScrollTrigger.create({
        trigger: para,
        start: "top 85%",
        toggleActions: "play none none none",
        onEnter: () => {
          gsap.to(para, { y: 0, opacity: 1, duration: 0.5, ease: "power1.inOut" });
        },
      });
    });
    }

    // Initialize all section animations
    heroSectionAnimation();
    headerAnimation();
    statementAnimation();
    skinPromoAnimation();
    trustedStatementAnimation();
    comfortSectionAnimation();
    uspIconsAnimation();
    statsSectionAnimation();
    howItWorksAnimation();
    symptomsSectionAnimation();
    logosSectionAnimation();
    advisorsSectionAnimation();
    hospitalsSectionAnimation();
    futureVisionSectionAnimation();
    footerAnimation();
    genericAnimations();
    genericAnimationsFast();
    articleParagraphsAnimation();

    // Refresh all ScrollTriggers after load (for accurate positioning)
    window.addEventListener("load", () => ScrollTrigger.refresh());
  }
});